import { ApiClient } from '../../core/services/api.service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/services/api.service";
export class FeatureService {
    constructor(http) {
        this.http = http;
    }
    calendar({ date, type, escludiTrattamento = null, isFirst = false, isCalendar = false, soloMiei = false }) {
        // @ts-ignore
        return this.http.get(`events?date=${date}&type=${type}${escludiTrattamento ? '&escludiTrattamento=' + escludiTrattamento : ''}${isFirst ? '&isFirst=true' : ''}${isCalendar ? '&isCalendar=true' : ''}${soloMiei ? '&soloMiei=true' : ''}`);
    }
    searchClient({ query }) {
        return this.http.get(`events/search?search=${query}`);
    }
    createEvent(formData) {
        return this.http.post(`events`, formData);
    }
    getSottoOperatori() {
        return this.http.get(`sotto-operatori`);
    }
    updateEvent(id, formData) {
        formData = Object.assign({}, formData, { '_method': 'PUT' });
        return this.http.post(`events/${id}`, formData);
    }
    patchEvent(id, formData) {
        formData = Object.assign({}, formData, { '_method': 'PATCH' });
        return this.http.post(`events/${id}`, formData);
    }
    deleteEvent(id, formData) {
        formData = Object.assign({}, formData, { '_method': 'DELETE' });
        return this.http.post(`events/${id}`, formData);
    }
    dashboard() {
        // @ts-ignore
        return this.http.get('dashboard');
    }
    // dashboardAppuntamenti(): Observable<any> {
    //
    //   return this.http.get('dashboard/appuntamenti');
    //
    // }
    checkupNonPianificati() {
        return this.http.get('checkup/pending');
    }
    nuovoCheckup(data) {
        return this.http.post('checkup/pending', data);
    }
    getCalendarUrl() {
        return this.http.get('account/calendar-url');
    }
    getGoogleConnectionUrl() {
        return this.http.getEndpoint('calendar/connect');
    }
    getGoogleDisconnectionUrl() {
        return this.http.getEndpoint('calendar/disconnect');
    }
    getTrattamentiAttivi(categoria) {
        return this.http.get(`${categoria}`);
    }
    getMantenimentiTerminati() {
        return this.http.get('mantenimenti/terminati');
    }
    sendConfirmRequest({ type, id }) {
        return this.http.post('events/send-confirm-request', { type, id });
    }
    fotoNonCaricate() {
        // @ts-ignore
        return this.http.get('user/foto-non-caricate');
    }
    deleteFtoNonCaricate(ids) {
        const data = {
            ids,
            _method: 'delete'
        };
        // @ts-ignore
        return this.http.post('user/foto-non-caricate', data);
    }
}
FeatureService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FeatureService_Factory() { return new FeatureService(i0.ɵɵinject(i1.ApiClient)); }, token: FeatureService, providedIn: "root" });
